import { Button, FormGroup } from "@shltelemedicine/shl-ui-lib";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { emailPattern } from "../../../../constants";
import TextFormInput from "../../TextInput/TextFormInput";
import styles from "./ViewFileForm.module.css";
export type ViewFileFormInputs = {
  username: string;
  password: string;
};

type ViewFileFormProps = {
  onSubmit?: (values: ViewFileFormInputs) => void;
};

const ViewFileForm = ({ onSubmit }: ViewFileFormProps) => {
  const {
    handleSubmit,
    control,
    formState: { errors: formErrors },
  } = useForm<ViewFileFormInputs>();

  const submitHandler = (values: ViewFileFormInputs) => {
    if (onSubmit) {
      onSubmit(values);
    }
  };

  return (
    <Form
      className="z-index-front d-md-flex justify-content-center"
      onSubmit={handleSubmit(submitHandler)}
    >
      <div className="mx-2">
        <FormGroup
          input={
            <TextFormInput
              name={"username"}
              control={control}
              rules={{
                required: true,
                pattern: emailPattern,
              }}
              input={{
                isInvalid: !!formErrors?.username,
                className: styles.input,
              }}
            />
          }
          label={
            <>
              <FormattedMessage id="USER.USERNAME" />:
            </>
          }
        />

        <FormGroup
          input={
            <TextFormInput
              name={"password"}
              control={control}
              rules={{
                required: true,
              }}
              input={{
                type: "password",
                isInvalid: !!formErrors?.password,
                className: styles.input,
              }}
            />
          }
          label={
            <>
              <FormattedMessage id="LOGIN.PASSWORD" />:
            </>
          }
        />
      </div>
      <div className="align-self-end mb-0 mx-2 mb-2 mt-3 mt-md-2 d-flex justify-content-center">
        <Button
          type="submit"
          bgColor="#435FC5"
          className="m-0 px-4 font-weight-bold"
        >
          <FormattedMessage id="VIEW_ECG.VIEW" />
        </Button>
      </div>
    </Form>
  );
};

export default ViewFileForm;
